module.exports = __webpack_public_path__ + "img/uicon.56815489.jpg";